import { Dayjs } from 'dayjs';
import { DeliveryRequest } from './deliveryRequest';
import { ProductSchedule } from './productSchedule';

export const DEVICE_ACTIVE = 'active';
export const DEVICE_CREATED = 'created';
export const DEVICE_TO_BE_DELETED = 'to-be-deleted';
export const TIPOS_SECTOR = ['Agrónomo', 'Industrial', 'Domestico'];

export type Device = {
  guid: string;
  attributes: {
    name: string;
    shared_by: string;
    is_ref_of: string;
    pointers: string[];
    identifier: string;
    workspace: string;
    last_location: CompleteLocation | null;
    parameters: DeviceParameter[];
    device_type_preset: string;
    device_type: string;
    last_data: DataPoint | null;
    state: string;
    tags: string[];
    alarm_states: {
      alarm_definition: string;
      last_updated: number;
      state: string;
    }[];
    delivery_configurations: string[];
    owner?: Owner;
    owner_guid?: string;
  };
};

export type Owner = {
  name: string;
  email?: string;
  guid: string;
};

export type RefactoredDevice = Device & {
  guid_original?: string;
  backgroundPercent: string;
  colorPercent: string;
  percent: number;
  volumen_aproximado: number;
  volumen_libre: number;
  device_type: string;
  capacidad: number;
  temperature: number;
  rawSensor: number;
  slotsNumber: number;
  unit: string;
  tipo_de_producto: string | null;
  numero_de_crianza: string | null;
  productSchedule: ProductSchedule | null;
  sector: number | null;
  last_revision: string | null;
  next_revision: string | null;
  calibrado: boolean | null;
  delivery_request_pending: DeliveryRequest[] | null;
};

export type DeviceParameter = {
  guid: string;
  identifier: string;
  value: any;
};

export type DataPoint = {
  date: Dayjs;
  data: DataPointValue[];
};

export type DataPointValue = { type: string; value: string; name: string };

export type DeviceType = {
  guid: string;
  type: string;
  attributes: {
    name: string;
    shared: boolean;
    is_ref_of: boolean;
    parameters: any; //TODO:
  };
};

export type Measure = {
  guid: string;
  attributes: {
    date: Dayjs;
    data: { type: string; value: any; name: string }[];
    // TODO: Location
  };
};

export type AlarmStateChange = {
  guid: string;
  attributes: {
    state: string;
    alarm_state: string;
    information: string;
    origin_alarm_state: string;
    created: Dayjs;
    device: string;
  };
};
export type AlarmState = {
  guid: string;
  attributes: {
    last_update: Dayjs;
    state: string;
    alarm_definition: string;
  };
};

export const DATE_FORMAT_NO_TIME = 'DD/MM/YYYY';

export const DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';

export const DATE_FORMAT_NOT_SECONDS = 'DD/MM/YYYY HH:mm';

export const DATE_FORMAT_SHORT = {
  dateStyle: 'short'
};
export const DATE_TIME_FORMAT_SHORT = {
  dateStyle: 'short',
  timeStyle: 'short'
};

export function show_date(date: any, format?: object) {
  let result = '';
  switch (typeof date) {
    case 'number':
      result = new Date(date).toLocaleString(navigator.language, format ?? DATE_TIME_FORMAT_SHORT);
      break;
    case 'object':
      result = new Date(date).toLocaleString(navigator.language, format ?? DATE_TIME_FORMAT_SHORT);
      break;
    case 'undefined':
      result = '-';
      break;
  }
  return result;
}

export type CompleteLocation = {
  identifier: string | null;
  formatedAddress: string | null;
  postalCode: string | null;
  locality: string | null;
  administrative_area_level_2: string | null;
  administrative_area_level_1: string | null;
  country: string | null;
  lat: number;
  lon: number;
};

export const percentDeviceTypes = [
  'preset:metrosil-v1',
  'preset:trackgas-v1-device-type',
  'preset:fuelme:level-sensor',
  'preset:trackgas-v1-sonda-presion-device-type',
  'preset:ocr-device-type:water',
  'preset:ocr-device-type:meter',
  'preset:trackgas-flow-sensor-v1'
];
